<template>
  <div class="w-full bg-f4f5f6 h-screen">
    <div
      v-if="agreementStatus && login.role == 'Admin'"
      class="cust-marquee py-3 pl-12 flex w-full justify-between"
    >
      <p class="flex fsize12 font-medium textff9493 items-center gap-3">
        <feather-icon
          icon="InfoIcon"
          class="textff9493 flex"
          svgClasses="w-5 h-5"
        />
        <span class="cursor-pointer font-bold textff9493"
          >Important Notice:</span
        >You have not yet signed the required legal agreement. To proceed kindly
        click here to review and sign the aggrement
      </p>
      <div class="flex gap-4 justify-end items-center pr-6">
        <p @click="eSignRequest" class="pr-12 textff9493 cursor-pointer">
          Complete Procedure
        </p>
        <feather-icon
          @click="changeStatus"
          icon="XIcon"
          class="textff9493 flex"
          svgClasses="w-5 h-5 cursor-pointer"
        />
      </div>
    </div>
    <div
      class="flex w-full seth-set bg-primary"
      :class="{ 'mt-12': agreementStatus && login.role == 'Admin' }"
    >
      <div class="lg:w-2/12 md:w-1/4 w-full flex items-center">
        <DashLeftMenu />
      </div>
      <div class="lg:w-10/12 md:w-3/4 h-full w-full pl-8 h-full">
        <!-- <Header /> -->

        <router-view></router-view>
      </div>
    </div>
  </div>
</template>
<script
  type="text/javascript"
  src="https://signdesk.in/api/eSignWidgetLive.js"
></script>

<script>
import DashLeftMenu from "./components/DashLeftMenu.vue";
import Header from "./components/Header.vue";
import { mapState } from "vuex";
import FeatherIcon from "../../../components/FeatherIcon.vue";

export default {
  components: {
    DashLeftMenu,
    Header,
    FeatherIcon,
  },

  computed: {
    ...mapState("brandProfile", ["brandProfile"]),
    ...mapState("admin", ["login", "selectedPlan", "agreementStatus"]),
    ...mapState("user", {
      selectedProject: "selectedProject",
    }),
  },

  methods: {
    async checkLogin() {
      this.token = this.$store.state.admin.login.token;
      // If user is already logged in notify
      if (this.token) {
        await this.getBrandProfile();

        // this.$router.push({ name: "dashboard" });
      } else {
        this.$router.push({ name: "login" });
      }
      if (
        ["Business", "Essential"].includes(
          this.selectedPlan[0].subscription.name
        )
      ) {
        this.$vs.theme({ primary: this.brandProfile.primaryColor });
        // this.$vs.setColor("primary", this.brandProfile.primaryColor);
        this.$store.commit(
          "UPDATE_PRIMARY_COLOR",
          this.brandProfile.primaryColor
        );
      }
    },

    async getBrandProfile() {
      let payloadBrand = {
        projectId: this.selectedProject._id,
        projectName: this.selectedProject.projectName,
      };
      await this.$store.dispatch("brandProfile/getBrandProfile", payloadBrand);
    },
    async updateuser() {
      await this.$store.dispatch("admin/editUserAsAdmin", {
        id: this.login._id,
        FirebaseToken: localStorage.getItem("FirebaseToken"),
      });
    },

    setASAP() {
      let d = document;
      let s = d.createElement("script");
      s.type = "text/javascript";
      s.defer = true;
      s.src =
        "https://desk.zoho.in/portal/api/web/inapp/73031000000622029?orgId=60014312957";

      d.getElementsByTagName("head")[0].appendChild(s);
    },

    async eSignRequest() {
      this.$vs.loading();
      try {
        let payload = {
          email: this.login.email,
          username: this.login.name,
          mobile: this.login.mobile,
          selectedPlan: this.selectedPlan[0].subscription._id,
        };
        let data = await this.$store.dispatch(
          "agreement/geteSignRequest",
          payload
        );
        this.docket_id = data.data.docket_id;
        this.signer_id = data.data.signer_info[0].signer_id;
        this.document_id = data.data.signer_info[0].document_id;
        console.log(data, "esignData");
        await this.eSignWidget(
          data.data.docket_id,
          data.data.signer_info[0].signer_id,
          data.data.signer_info[0].document_id,
          data.data.agreementPlan,
          data.data.version
        );
        this.$vs.loading.close();
      } catch (error) {
        console.log(error);
        this.$vs.loading.close();
        s;
      }
      // await this.AgreementData();
    },

    async eSignWidget(docket_id, signer_id, document_id, plan, version) {
      var self = this;
      var clientData = {
        document_id: document_id,
        signer_id: signer_id,
        docket_id: docket_id,
        id: process.env.VUE_APP_SIGN_DESK_APP_ID,
        getWidgetToken: async function (result) {
          // function will return widget token
          console.log(result, "TOKEN");
          self.token = result;
          let payload = {
            widget_token: result,
            time_stamp: Date.now(),
            // time_stamp: "2023-04-26",
            docket_id: self.docket_id,
          };
          await self.$store.dispatch("agreement/geteSignWidget", payload);
        },
        signatureStatus: async function (result) {
          // function will return signature status
          if (result.status === "success") {
            await self.$store.dispatch("user/updateProject", {
              projectId: process.env.VUE_APP_ID,
              agreementSigned: {
                version: version,
                selectedPlan: plan,
              },
            });
            self.$store.commit("admin/SET_AGREEMENT_STATUS", {
              key: "agreementStatus",
              value: false,
            });
          } else if (result.status === "failed") {
            self.terms = false;
          }
        },
        errorLog: function (result) {
          // function will return error
          console.log(result, "ERROR");
        },
      };
      // function call to load Signature Panel
      await esignWidgetCall(clientData);
    },
    async AgreementData() {
      let payload = {
        getAll: true,
        isActive: true,
        published: true,
        selectedPlan: this.selectedPlan[0].subscription._id,
      };
      let { data } = await this.$store.dispatch(
        "agreement/GetAgreement",
        payload
      );
      this.AgreementDatas = data.data[0];
    },

    changeStatus() {
      this.$store.commit("admin/SET_AGREEMENT_STATUS", {
        key: "agreementStatus",
        value: false,
      });
    },
  },

  async mounted() {
    try {
      this.$vs.loading();
      await this.checkLogin();
      // this.$vs.setColor("primary", this.brandProfile.primaryColor);
      // this.$store.commit("UPDATE_PRIMARY_COLOR", this.brandProfile.primaryColor);
      console.log(localStorage.getItem("FirebaseToken"), "token");
      await this.setASAP();

      await this.updateuser();
      this.AgreementData();

      this.$vs.loading.close();
    } catch (err) {
      console.log(err);
    }
  },
};
</script>

<style>
/* .v-enter-active,
.v-leave-active {
  transition: opacity 0.5s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
} */
.textff9493 {
  color: #ff9493;
}
.cust-marquee {
  overflow: hidden;
  position: relative;
  background: #ffede0;
  color: #fff;
  border: none;
  font-weight: 600;
  z-index: 99999;
}
</style>
